import React,{Component} from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import BrandInfo from '../../BrandInfo';
import BrandSpecialPricing from '../../BrandSpecialPricing';

class BrandView extends Component {
  componentDidMount(){
    if(this.props.needsLoading){
      this.props.loadBrand(this.props.brandId);
    }
  }


  render(){
    const {match,name,brandId,needsLoading} = this.props;

    return (
      <Container>
        <Row>
          <Col xs='12'>
            <br />
            <h6>Brand</h6>
            <h3>{name || 'Loading...'}</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/edit`}
                  activeClassName='active'
                >
                  Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/pricing`}
                  activeClassName='active'
                >
                  Special Pricing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink

                  tag={Link}
                  to={`${match.url}/experiences`}
                  activeClassName='active'
                >
                  Experiences
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        {!needsLoading && (
          <Switch>
            <Route
              path={`${match.url}/edit`}
              render={() => (<BrandInfo brandId={brandId} />)}
            />
            <Route
              path={`${match.url}/pricing`}
              render={() => (<BrandSpecialPricing brandId={brandId} />)}
            />
          </Switch>
        )}
      </Container>
    )
  }
}

export default BrandView;



// WEBPACK FOOTER //
// ./src/routes/BrandView/components/BrandView.js